const getDefaultLogo = () => {
  const logoUrl = import.meta.env.VITE_DEFAULT_LOGO_URL;
  return `/src/assets/${logoUrl}`;
};

export default getDefaultLogo;
